import React, { Component, Fragment } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import InvoicesIndex from "../../invoices/index";

export default class Index extends Component {
  render() {
    return <InvoicesIndex/>;
  }
}
